export function getLimit(length: number, sign: '+' | '-') {
  return +(sign === '-' ? sign : '').padEnd(length, '9');
}
